import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class TokenInterceptor implements HttpInterceptor {

 

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    const injector = inject(Injector);
    const router = inject(Router);

    const token = localStorage.getItem('accessToken');
    
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const headers: Record<string, string> = {
      'X-Client-Type': 'web',   // ✅ ADD THIS
      'X-Timezone': timezone
    };

    if (req.headers.get('NoAuth')){
            return next.handle(req.clone());
    }

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;

      // req = req.clone({
      //   setHeaders: {
      //     Authorization: `Bearer ${token}`
      //   }
      // });
    }

    const clonedReq = req.clone({
      setHeaders: headers
    });

    return next.handle(clonedReq).pipe(
      catchError((err: HttpErrorResponse) => {

        // 🔥 Handle LOGIN JWT expiry globally
        if (
          err.status === 401 &&
          (err.error?.message === 'jwt expired' ||
           err.error?.code === 'TOKEN_EXPIRED')
        ) {
          const auth = injector.get(AuthService);
          auth.logout(() => {
                router.navigate(['/auth/login'], {
                queryParams: { reason: 'sessionExpired' }
              });
                
              });
              
        }

        return throwError(() => err);
      })
    );
  }
}
